














































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { IFilter, ISorter } from "@/models/tables";
import { DataModules } from "@/store/modules/data";
import { FilterTypes, FilterOperators } from "@/data/table";
import { IBrand } from "@/models/brands";

@Component
export default class TermsAndConditionsTable extends Mixins(
  FilteringSortingTableStore
) {
  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ default: "" })
  public currentId!: string;

  public loading = true;

  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.created")
    }
  ];

  public dataModule = DataModules.TERMS_AND_CONDITIONS;

  public created() {
    this.apiProps = {
      brand_id: this.brandId
    };
    this.getData();
  }

  public viewTerms(termsId) {
    this.$store.dispatch(
      `data/${DataModules.TERMS_AND_CONDITIONS}/openPreviewModal`,
      {
        props: {
          termsId
        }
      }
    );
  }
}
